webpackJsonp([25],{

/***/ 1320:
/***/ (function(module, exports) {

module.exports = BMap;

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMaxWaterLevel = exports.getEnergyList = exports.waterElecListt = exports.getEnergyData = exports.downloadHistory = exports.getDatas = exports.updateAlarmContactGroup = exports.addAlarmContactGroup = exports.deleteAlarmContactGroups = exports.getAlarmContactGroups = exports.deleteAlarmContactUsersL2 = exports.deleteAlarmContactUsers = exports.updateAlarmContactUserL2 = exports.updateAlarmContactUser = exports.addAlarmContactUserL2 = exports.addAlarmContactUser = exports.getAlarmContactUsersL2 = exports.getAlarmContactUsers = exports.getAllAlarmContactsL2 = exports.getAllAlarmContacts = exports.getDataPointTemplateList = exports.downloadAlarmHistoryData = exports.editAlarmInfo = exports.getAlarmInfo = exports.getAlarmHistory = exports.editTriggerL2 = exports.editTrigger = exports.addTriggerL2 = exports.addTrigger = exports.deleteTriggerL2 = exports.deleteTrigger = exports.getTriggerL2 = exports.getTrigger = exports.getTriggersL2 = exports.getTriggers = exports.setDataPoint = exports.getMultiData = exports.getLastData = exports.getDataPointInfo = exports.getDevice = exports.addDefaultDevs = exports.addDevice = exports.getDevGroups = exports.getDevCountByUid = exports.getProtocolCountByUid = exports.getOnlineCountByUid = exports.getData = exports.saveUserRoles = exports.addUser = exports.delRole = exports.updateRole = exports.addRole = exports.getAllListOfLevel = exports.getAllRoles = exports.getRoles = exports.getRoleMenus = exports.getDevExt = exports.delDevExt = exports.updateDevExt = exports.addDevExt = exports.getDevExts = exports.getDevs = exports.requestLoginL2 = exports.getDevsL2 = exports.verificationCodeL2 = exports.DeleteUserL2 = exports.registerSubUserL2 = exports.getUsersL2 = exports.getUserL2 = exports.ModifyUserL2 = exports.modifyMobileL2 = exports.resetPasswordL2 = exports.sendVerificationCodeL2 = exports.modifyPasswordL2 = exports.modifyMobile = exports.resetPwd = exports.sendVerifyCodeSms = exports.getUserDevs = exports.sendVerificationCode = exports.sendVerificationCode1 = exports.unbindWechatL2 = exports.unbindWechat = exports.getWechatBindListL2 = exports.getWechatBindList = exports.DeleteUser = exports.ModifyUser = exports.registerSubUser = exports.modifyPassword = exports.resetPassword = exports.verificationCode = exports.getUser = exports.saveUserDevs = exports.getUsers = exports.chkVerifyCode = exports.requestLogin = undefined;

var _assign = __webpack_require__(82);

var _assign2 = _interopRequireDefault(_assign);

var _axios = __webpack_require__(160);

var _axios2 = _interopRequireDefault(_axios);

var _store = __webpack_require__(81);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var base = '/apis';
var service = '/service';

var requestLogin = exports.requestLogin = function requestLogin(params) {
    return _axios2.default.post(base + '/user/login', params).then(function (res) {
        return res.data;
    });
};

var chkVerifyCode = exports.chkVerifyCode = function chkVerifyCode(params) {
    return _axios2.default.get(service + '/sysUser/chkVerifyCode', params).then(function (res) {
        return res.data;
    });
};
var getUsers = exports.getUsers = function getUsers(params) {
    return _axios2.default.post(base + '/user/getUsers', params).then(function (res) {
        return res.data;
    });
};

var saveUserDevs = exports.saveUserDevs = function saveUserDevs(params) {
    return _axios2.default.post(service + '/sysUser/saveUserDevs', params).then(function (res) {
        return res.data;
    });
};
var getUser = exports.getUser = function getUser(params) {
    console.log(sessionStorage.getItem('account'), 99999);
    if (_store2.default.getters.roles === 'admin') {
        return (0, _axios2.default)({
            method: 'post',
            url: base + '/user/getUser',
            data: params
        }).then(function (res) {
            return res.data;
        });
    } else {
        return (0, _axios2.default)({
            method: 'get',
            url: service + '/sysUser/getByAccount',
            data: { params: params }
        }).then(function (res) {
            var obj = {
                tel: res.data.data.mobile
            };
            (0, _assign2.default)(res.data.data, obj);
            return res.data;
        });
    }
};
var verificationCode = exports.verificationCode = function verificationCode(params) {
    if (_store2.default.getters.roles == 'admin') {
        return (0, _axios2.default)({
            method: 'post',
            url: base + '/user/getVerifyThroughCodeByVerificationCode',
            data: params
        }).then(function (res) {
            return res.data;
        });
    } else {
        var _params = {
            mobile: _params.emailOrPhoneNumber,
            verifyCode: _params.verificationCode
        };
        return (0, _axios2.default)({
            method: 'post',
            url: service + '/sysUser/modifyMobile',
            data: _params
        }).then(function (res) {
            return res.data;
        });
    }
};
var resetPassword = exports.resetPassword = function resetPassword(params) {
    if (_store2.default.getters.roles == 'admin') {
        return (0, _axios2.default)({
            method: 'post',
            url: base + '/user/modifyPasswordByVerifyThroughCode',
            data: params
        }).then(function (res) {
            return res.data;
        });
    } else {
        var _params2 = {
            newPassword: _params2.password,
            oldPassword: _params2.oldPassword,
            rePassword: _params2.repassword
        };
        return (0, _axios2.default)({
            method: 'post',
            url: service + '/sysUser/modifyPwd',
            data: _params2
        }).then(function (res) {
            return res.data;
        });
    }

    return _axios2.default.post(base + '/user/modifyPasswordByVerifyThroughCode', params).then(function (res) {
        return res.data;
    });
};
var modifyPassword = exports.modifyPassword = function modifyPassword(params) {
    return _axios2.default.post(base + '/user/modifyPassword', params).then(function (res) {
        return res.data;
    });
};
var registerSubUser = exports.registerSubUser = function registerSubUser(params) {
    return _axios2.default.post(base + '/user/regUser2', params).then(function (res) {
        return res.data;
    });
};
var ModifyUser = exports.ModifyUser = function ModifyUser(params) {
    return _axios2.default.post(base + '/user/editUser', params).then(function (res) {
        return res.data;
    });
};
var DeleteUser = exports.DeleteUser = function DeleteUser(params) {
    return _axios2.default.post(base + '/user/deleteUsers', params).then(function (res) {
        return res.data;
    });
};
var getWechatBindList = exports.getWechatBindList = function getWechatBindList(params) {
    return _axios2.default.post(base + '/user/getWechatBindList', params).then(function (res) {
        return res.data;
    });
};
var getWechatBindListL2 = exports.getWechatBindListL2 = function getWechatBindListL2(params) {
    return _axios2.default.post(service + '/user/getWechatBindList', params).then(function (res) {
        return res.data;
    });
};
var unbindWechat = exports.unbindWechat = function unbindWechat(params) {
    return _axios2.default.post(base + '/user/unbindWechat', params).then(function (res) {
        return res.data;
    });
};
var unbindWechatL2 = exports.unbindWechatL2 = function unbindWechatL2(params) {
    return _axios2.default.post(service + '/user/unbindWechat', params).then(function (res) {
        return res.data;
    });
};
var sendVerificationCode1 = exports.sendVerificationCode1 = function sendVerificationCode1(params) {

    if (_store2.default.getters.roles == 'admin') {
        return (0, _axios2.default)({
            method: 'post',
            url: base + '/user/sendVerificationCode',
            data: params
        }).then(function (res) {
            return res.data;
        });
    } else {
        params.emailOrPhoneNumber;
        return (0, _axios2.default)({
            method: 'get',
            url: service + '/sysUser/sendVerifyCodeSms',
            data: { params: { mobile: params.emailOrPhoneNumber } }
        }).then(function (res) {
            return res.data;
        });
    }
};
var sendVerificationCode = exports.sendVerificationCode = function sendVerificationCode(params) {
    return _axios2.default.post(base + '/user/sendVerificationCode', params).then(function (res) {
        return res.data;
    });
};

var getUserDevs = exports.getUserDevs = function getUserDevs(params) {
    return _axios2.default.get(service + '/sysUser/getUserDevs', params).then(function (res) {
        return res.data;
    });
};

var sendVerifyCodeSms = exports.sendVerifyCodeSms = function sendVerifyCodeSms(params) {
    return _axios2.default.get(service + '/sysUser/sendVerifyCodeSms', params).then(function (res) {
        return res.data;
    });
};

var resetPwd = exports.resetPwd = function resetPwd(params) {
    return _axios2.default.post(service + '/sysUser/resetPwd', params).then(function (res) {
        return res.data;
    });
};
var modifyMobile = exports.modifyMobile = function modifyMobile(params) {
    return _axios2.default.post(service + '/sysUser/modifyMobile', params).then(function (res) {
        return res.data;
    });
};

var modifyPasswordL2 = exports.modifyPasswordL2 = function modifyPasswordL2(params) {
    return _axios2.default.post(service + '/sysUser/modifyPwd', params).then(function (res) {
        return res.data;
    });
};
var sendVerificationCodeL2 = exports.sendVerificationCodeL2 = function sendVerificationCodeL2(params) {
    return _axios2.default.get(service + '/sysUser/sendVerifyCodeSms', params).then(function (res) {
        return res.data;
    });
};
var resetPasswordL2 = exports.resetPasswordL2 = function resetPasswordL2(params) {
    return _axios2.default.post(service + '/sysUser/resetPwd', params).then(function (res) {
        return res.data;
    });
};
var modifyMobileL2 = exports.modifyMobileL2 = function modifyMobileL2(params) {
    return _axios2.default.post(service + '/sysUser/modifyMobile', params).then(function (res) {
        return res.data;
    });
};
var ModifyUserL2 = exports.ModifyUserL2 = function ModifyUserL2(params) {
    return _axios2.default.post(service + '/sysUser/modifyUser', params).then(function (res) {
        return res.data;
    });
};
var getUserL2 = exports.getUserL2 = function getUserL2(params) {
    return _axios2.default.get(service + '/sysUser/getByAccount', params).then(function (res) {
        return res.data;
    });
};
var getUsersL2 = exports.getUsersL2 = function getUsersL2(params) {
    return _axios2.default.post(service + '/sysUser/listpaging', params).then(function (res) {
        return res.data;
    });
};
var registerSubUserL2 = exports.registerSubUserL2 = function registerSubUserL2(params) {
    return _axios2.default.post(service + '/sysUser/add', params).then(function (res) {
        return res.data;
    });
};
var DeleteUserL2 = exports.DeleteUserL2 = function DeleteUserL2(params) {
    return _axios2.default.post(service + '/sysUser/delByAccount', params).then(function (res) {
        return res.data;
    });
};
var verificationCodeL2 = exports.verificationCodeL2 = function verificationCodeL2(params) {
    return _axios2.default.get(service + '/sysUser/chkVerifyCode', params).then(function (res) {
        return res.data;
    });
};
var getDevsL2 = exports.getDevsL2 = function getDevsL2(params) {
    return _axios2.default.post(service + '/sysUser/getUserDevsByCondition', params).then(function (res) {
        return res.data;
    });
};
var requestLoginL2 = exports.requestLoginL2 = function requestLoginL2(params) {
    return _axios2.default.post(service + '/sysUser/login', params).then(function (res) {
        return res.data;
    });
};
var getDevs = exports.getDevs = function getDevs(params) {
    return _axios2.default.post(base + '/dev/getDevs', params).then(function (res) {
        return res.data;
    });
};

var getDevExts = exports.getDevExts = function getDevExts(params) {
    return _axios2.default.get(service + '/devExt/list', params).then(function (res) {
        return res.data;
    });
};
var addDevExt = exports.addDevExt = function addDevExt(params) {
    return _axios2.default.post(service + '/devExt/add', params).then(function (res) {
        return res.data;
    });
};
var updateDevExt = exports.updateDevExt = function updateDevExt(params) {
    return _axios2.default.post(service + '/devExt/update', params).then(function (res) {
        return res.data;
    });
};
var delDevExt = exports.delDevExt = function delDevExt(params) {
    return _axios2.default.delete(service + '/devExt/del', params).then(function (res) {
        return res.data;
    });
};
var getDevExt = exports.getDevExt = function getDevExt(params) {
    return _axios2.default.delete(service + '/devExt/getByDevId', params).then(function (res) {
        return res.data;
    });
};

var getRoleMenus = exports.getRoleMenus = function getRoleMenus(params) {
    return _axios2.default.get(service + '/sysUser/getUserRoles', params).then(function (res) {
        return res.data;
    });
};
var getRoles = exports.getRoles = function getRoles(params) {
    return _axios2.default.get(service + '/sysRole/list', params).then(function (res) {
        return res.data;
    });
};
var getAllRoles = exports.getAllRoles = function getAllRoles(params) {
    return _axios2.default.get(service + '/sysRole/allList', params).then(function (res) {
        return res.data;
    });
};
var getAllListOfLevel = exports.getAllListOfLevel = function getAllListOfLevel(params) {
    return _axios2.default.get(service + '/sysRole/allListOfLevel', params).then(function (res) {
        return res.data;
    });
};
var addRole = exports.addRole = function addRole(params) {
    return _axios2.default.post(service + '/sysRole/add', params).then(function (res) {
        return res.data;
    });
};
var updateRole = exports.updateRole = function updateRole(params) {
    return _axios2.default.post(service + '/sysRole/update', params).then(function (res) {
        return res.data;
    });
};
var delRole = exports.delRole = function delRole(params) {
    return _axios2.default.delete(service + '/sysRole/del', params).then(function (res) {
        return res.data;
    });
};
var addUser = exports.addUser = function addUser(params) {
    return _axios2.default.post(service + '/sysUser/add', params).then(function (res) {
        return res.data;
    });
};
var saveUserRoles = exports.saveUserRoles = function saveUserRoles(params) {
    return _axios2.default.post(service + '/sysUser/saveUserRoles', params).then(function (res) {
        return res.data;
    });
};

var getData = exports.getData = function getData(params) {
    return _axios2.default.post(base + '/datadic/getData', params).then(function (res) {
        return res.data;
    });
};

var getOnlineCountByUid = exports.getOnlineCountByUid = function getOnlineCountByUid(params) {
    return _axios2.default.post(base + '/dev/getOnlineCountByUid', params).then(function (res) {
        return res.data;
    });
};

var getProtocolCountByUid = exports.getProtocolCountByUid = function getProtocolCountByUid(params) {
    return _axios2.default.post(base + '/dev/getProtocolCountByUid', params).then(function (res) {
        return res.data;
    });
};

var getDevCountByUid = exports.getDevCountByUid = function getDevCountByUid(params) {
    return _axios2.default.post(base + '/dev/getDevCountByUid', params).then(function (res) {
        return res.data;
    });
};

var getDevGroups = exports.getDevGroups = function getDevGroups(params) {
    return _axios2.default.post(base + '/dev/getDevGroups', params).then(function (res) {
        return res.data;
    });
};

var addDevice = exports.addDevice = function addDevice(params) {
    return _axios2.default.post(base + '/dev/addDevice', params).then(function (res) {
        return res.data;
    });
};

var addDefaultDevs = exports.addDefaultDevs = function addDefaultDevs(params) {
    return _axios2.default.post(base + '/dev/addDefaultDevs', params).then(function (res) {
        return res.data;
    });
};
var getDevice = exports.getDevice = function getDevice(params) {
    return _axios2.default.post(base + '/dev/getDevice', params).then(function (res) {
        return res.data;
    });
};
var getDataPointInfo = exports.getDataPointInfo = function getDataPointInfo(params) {
    return _axios2.default.post(base + '/datadic/getDataPointInfoByDevice', params).then(function (res) {
        return res.data;
    });
};
var getLastData = exports.getLastData = function getLastData(params) {
    return _axios2.default.post(base + '/datadic/getLastData', params).then(function (res) {
        return res.data;
    });
};
var getMultiData = exports.getMultiData = function getMultiData(params) {
    return _axios2.default.post(base + '/datadic/getMultiCurveDataPointHistory', params).then(function (res) {
        return res.data;
    });
};
var setDataPoint = exports.setDataPoint = function setDataPoint(params) {
    return _axios2.default.post(service + '/devData/setDataPoint', params).then(function (res) {
        return res.data;
    });
};

var getTriggers = exports.getTriggers = function getTriggers(params) {
    return _axios2.default.post(base + '/trigger/getTriggers', params).then(function (res) {
        return res.data;
    });
};
var getTriggersL2 = exports.getTriggersL2 = function getTriggersL2(params) {
    return _axios2.default.post(service + '/trigger/getTriggers', params).then(function (res) {
        return res.data;
    });
};
var getTrigger = exports.getTrigger = function getTrigger(params) {
    return _axios2.default.post(base + '/trigger/getTrigger', params).then(function (res) {
        return res.data;
    });
};
var getTriggerL2 = exports.getTriggerL2 = function getTriggerL2(params) {
    return _axios2.default.post(service + '/trigger/getTrigger', params).then(function (res) {
        return res.data;
    });
};
var deleteTrigger = exports.deleteTrigger = function deleteTrigger(params) {
    return _axios2.default.post(base + '/trigger/deleteTriggers', params).then(function (res) {
        return res.data;
    });
};
var deleteTriggerL2 = exports.deleteTriggerL2 = function deleteTriggerL2(params) {
    return _axios2.default.post(service + '/trigger/deleteTriggers', params).then(function (res) {
        return res.data;
    });
};
var addTrigger = exports.addTrigger = function addTrigger(params) {
    return _axios2.default.post(base + '/trigger/addTrigger', params).then(function (res) {
        return res.data;
    });
};
var addTriggerL2 = exports.addTriggerL2 = function addTriggerL2(params) {
    return _axios2.default.post(service + '/trigger/addTrigger', params).then(function (res) {
        return res.data;
    });
};
var editTrigger = exports.editTrigger = function editTrigger(params) {
    return _axios2.default.post(base + '/trigger/editTrigger', params).then(function (res) {
        return res.data;
    });
};
var editTriggerL2 = exports.editTriggerL2 = function editTriggerL2(params) {
    return _axios2.default.post(service + '/trigger/editTrigger', params).then(function (res) {
        return res.data;
    });
};
var getAlarmHistory = exports.getAlarmHistory = function getAlarmHistory(params) {
    return _axios2.default.post(base + '/trigger/getAlarmHistory', params).then(function (res) {
        return res.data;
    });
};
var getAlarmInfo = exports.getAlarmInfo = function getAlarmInfo(params) {
    return _axios2.default.post(base + '/trigger/getAlarmInfo', params).then(function (res) {
        return res.data;
    });
};
var editAlarmInfo = exports.editAlarmInfo = function editAlarmInfo(params) {
    return _axios2.default.post(base + '/trigger/editAlarmInfo', params).then(function (res) {
        return res.data;
    });
};
var downloadAlarmHistoryData = exports.downloadAlarmHistoryData = function downloadAlarmHistoryData(params) {
    return (0, _axios2.default)({
        method: 'post',
        responseType: 'blob',
        url: base + '/download/downloadAlarmHistoryData',
        data: params
    }).then(function (res) {
        return res.data;
    });
};

var getDataPointTemplateList = exports.getDataPointTemplateList = function getDataPointTemplateList(params) {
    return _axios2.default.post(base + '/template/getDataPointTemplateList', params).then(function (res) {
        return res.data;
    });
};
var getAllAlarmContacts = exports.getAllAlarmContacts = function getAllAlarmContacts(params) {
    return _axios2.default.post(base + '/alarmContact/getAllAlarmContacts', params).then(function (res) {
        return res.data;
    });
};
var getAllAlarmContactsL2 = exports.getAllAlarmContactsL2 = function getAllAlarmContactsL2(params) {
    return _axios2.default.post(service + '/alarmContact/getAllAlarmContacts', params).then(function (res) {
        return res.data;
    });
};
var getAlarmContactUsers = exports.getAlarmContactUsers = function getAlarmContactUsers(params) {
    return _axios2.default.post(base + '/alarmContact/getAlarmContactUsers', params).then(function (res) {
        return res.data;
    });
};
var getAlarmContactUsersL2 = exports.getAlarmContactUsersL2 = function getAlarmContactUsersL2(params) {
    return _axios2.default.post(service + '/alarmContact/getAlarmContactUsers', params).then(function (res) {
        return res.data;
    });
};
var addAlarmContactUser = exports.addAlarmContactUser = function addAlarmContactUser(params) {
    return _axios2.default.post(base + '/alarmContact/addAlarmContactUser', params).then(function (res) {
        return res.data;
    });
};
var addAlarmContactUserL2 = exports.addAlarmContactUserL2 = function addAlarmContactUserL2(params) {
    return _axios2.default.post(service + '/alarmContact/addAlarmContactUser', params).then(function (res) {
        return res.data;
    });
};
var updateAlarmContactUser = exports.updateAlarmContactUser = function updateAlarmContactUser(params) {
    return _axios2.default.post(base + '/alarmContact/updateAlarmContactUser', params).then(function (res) {
        return res.data;
    });
};
var updateAlarmContactUserL2 = exports.updateAlarmContactUserL2 = function updateAlarmContactUserL2(params) {
    return _axios2.default.post(service + '/alarmContact/updateAlarmContactUser', params).then(function (res) {
        return res.data;
    });
};
var deleteAlarmContactUsers = exports.deleteAlarmContactUsers = function deleteAlarmContactUsers(params) {
    return _axios2.default.post(base + '/alarmContact/deleteAlarmContactUsers', params).then(function (res) {
        return res.data;
    });
};
var deleteAlarmContactUsersL2 = exports.deleteAlarmContactUsersL2 = function deleteAlarmContactUsersL2(params) {
    return _axios2.default.post(service + '/alarmContact/deleteAlarmContactUsers', params).then(function (res) {
        return res.data;
    });
};
var getAlarmContactGroups = exports.getAlarmContactGroups = function getAlarmContactGroups(params) {
    return _axios2.default.post(base + '/alarmContactGroup/getAlarmContactGroups', params).then(function (res) {
        return res.data;
    });
};
var deleteAlarmContactGroups = exports.deleteAlarmContactGroups = function deleteAlarmContactGroups(params) {
    return _axios2.default.post(base + '/alarmContactGroup/deleteAlarmContactGroups', params).then(function (res) {
        return res.data;
    });
};
var addAlarmContactGroup = exports.addAlarmContactGroup = function addAlarmContactGroup(params) {
    return _axios2.default.post(base + '/alarmContactGroup/addAlarmContactGroup', params).then(function (res) {
        return res.data;
    });
};
var updateAlarmContactGroup = exports.updateAlarmContactGroup = function updateAlarmContactGroup(params) {
    return _axios2.default.post(base + '/alarmContactGroup/updateAlarmContactGroup', params).then(function (res) {
        return res.data;
    });
};

var getDatas = exports.getDatas = function getDatas(params) {
    return _axios2.default.post(base + '/datadic/getDatas', params).then(function (res) {
        return res.data;
    });
};

var downloadHistory = exports.downloadHistory = function downloadHistory(params) {
    return (0, _axios2.default)({
        method: 'post',
        responseType: 'blob',
        url: base + '/download/downloadMultiCurveDataPointHistory',
        data: params
    }).then(function (res) {
        return res.data;
    });
};

var getEnergyData = exports.getEnergyData = function getEnergyData(params) {
    return _axios2.default.get(service + '/devData/allList', params).then(function (res) {
        return res.data;
    });
};

var waterElecListt = exports.waterElecListt = function waterElecListt(params) {
    return _axios2.default.get(service + '/devData/waterElecList', params).then(function (res) {
        return res.data;
    });
};

var getEnergyList = exports.getEnergyList = function getEnergyList(params) {
    return _axios2.default.get(service + '/devEnergyConsume/allList', params).then(function (res) {
        return res.data;
    });
};

var getMaxWaterLevel = exports.getMaxWaterLevel = function getMaxWaterLevel(params) {
    return _axios2.default.get(service + '/devExt/getByDevId', params).then(function (res) {
        return res.data;
    });
};

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAccount = getAccount;
exports.setAccount = setAccount;
exports.removeAccount = removeAccount;


var ACCOUNT = 'account';

function getAccount() {
  return sessionStorage.getItem(ACCOUNT);
}

function setAccount(token) {
  return sessionStorage.setItem(ACCOUNT, token);
}

function removeAccount() {
  return sessionStorage.removeItem(ACCOUNT);
}

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.NumTwoPoint = function (value) {
	if (value == undefined || value == 0) {
		return '0.00';
	}
	return Number(value).toFixed(2);
};

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _regenerator = __webpack_require__(176);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(70);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(175);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _router = __webpack_require__(80);

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__(81);

var _store2 = _interopRequireDefault(_store);

var _elementUi = __webpack_require__(161);

var _auth = __webpack_require__(173);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var whiteList = ['/login', '/auth-redirect', '/forgotPwd', '/forgotPwdL2'];

_router2.default.beforeEach(function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(to, from, next) {
    var hasAccount, hasRoles, roles, accessRoutes;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            hasAccount = (0, _auth.getAccount)();

            if (!hasAccount) {
              _context.next = 30;
              break;
            }

            if (!(to.path === '/login')) {
              _context.next = 6;
              break;
            }

            next();
            _context.next = 28;
            break;

          case 6:
            hasRoles = _store2.default.getters.roles && _store2.default.getters.roles.length > 0;

            if (!hasRoles) {
              _context.next = 11;
              break;
            }

            next();
            _context.next = 28;
            break;

          case 11:
            _context.prev = 11;
            _context.next = 14;
            return _store2.default.dispatch('user/getInfo');

          case 14:
            roles = _context.sent;
            _context.next = 17;
            return _store2.default.dispatch('permission/generateRoutes', roles);

          case 17:
            accessRoutes = _context.sent;

            _router2.default.addRoutes(accessRoutes);

            next((0, _extends3.default)({}, to, { replace: true }));
            _context.next = 28;
            break;

          case 22:
            _context.prev = 22;
            _context.t0 = _context['catch'](11);
            _context.next = 26;
            return _store2.default.dispatch('user/resetAccount');

          case 26:
            _elementUi.Message.error(_context.t0 || 'Has Error');
            next('/login?redirect=' + to.path);

          case 28:
            _context.next = 31;
            break;

          case 30:

            if (whiteList.indexOf(to.path) !== -1) {
              next();
            } else {
              next('/login?redirect=' + to.path);
            }

          case 31:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined, [[11, 22]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

_router2.default.afterEach(function () {});

/***/ }),

/***/ 367:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(687)

var Component = __webpack_require__(68)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(708),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}

};

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(70);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(109);

var _store = __webpack_require__(81);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            sysName: "VUEADMIN",
            collapsed: false,
            sysUserName: "",
            sysUserAvatar: "../assets/pic.gif",
            user: {},
            form: {
                name: "",
                region: "",
                date1: "",
                date2: "",
                delivery: false,
                type: [],
                resource: "",
                desc: ""
            }
        };
    },

    methods: {
        onSubmit: function onSubmit() {
            console.log("submit!");
        },
        handleopen: function handleopen() {},
        handleclose: function handleclose() {},

        handleselect: function handleselect(a, b) {},

        logout: function logout() {
            var _this = this;
            this.$confirm("确认退出吗?", "提示", {}).then(function () {
                sessionStorage.removeItem("user");
                sessionStorage.removeItem('account');
                sessionStorage.removeItem('token');
                _store2.default.dispatch('user/logout');
                _this.$router.push("/login");
            }).catch(function () {});
        },

        collapse: function collapse() {
            this.collapsed = !this.collapsed;
        },

        showMenu: function showMenu(i, status) {
            this.$refs.menuCollapsed.getElementsByClassName("submenu-hook-" + i)[0].style.display = status ? "block" : "none";
        }
    },
    mounted: function mounted() {
        var user = sessionStorage.getItem("user");
        console.log(user);
        if (user) {
            user = JSON.parse(user);
            this.sysUserName = user.account || "";
            this.sysUserAvatar = user.avatar || "";
        }
    },

    computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['permission_routes']))
};

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(422);

var _stringify2 = _interopRequireDefault(_stringify);

var _api = __webpack_require__(163);

var _jsMd = __webpack_require__(370);

var _jsMd2 = _interopRequireDefault(_jsMd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            logining: false,
            spypassword: "text",
            ruleForm: {
                account: "",
                password: ""
            },
            rules2: {
                account: [{ required: true, message: "请输入账号", trigger: "blur" }],
                password: [{ required: true, message: "请输入密码", trigger: "blur" }]
            },
            directory: "",
            checked: true
        };
    },
    mounted: function mounted() {
        this.getCookie();
    },

    methods: {
        handleReset2: function handleReset2() {
            this.$refs.ruleForm.resetFields();
        },
        handleSubmit2: function handleSubmit2(ev) {
            var _this2 = this;

            var _this = this;
            this.$refs.ruleForm.validate(function (valid) {
                if (valid) {
                    _this2.logining = true;

                    if (_this2.checked) {
                        _this2.setCookie(_this2.ruleForm.account, _this2.ruleForm.password, 7);
                    } else {
                        _this2.clearCookie();
                    }

                    var loginParams = {
                        account: _this2.ruleForm.account,
                        password: (0, _jsMd2.default)(_this2.ruleForm.password)
                    };
                    (0, _api.requestLoginL2)(loginParams).then(function (data) {
                        _this2.logining = false;
                        var status = data.status,
                            info = data.info,
                            user = data.user;

                        user = data.data;
                        if (status !== 0) {
                            _this2.$message({
                                message: info,
                                type: "error"
                            });
                            _this2.logining = false;
                        } else {
                            sessionStorage.setItem("user", (0, _stringify2.default)(user));
                            sessionStorage.setItem("account", (0, _stringify2.default)(user.account));
                            sessionStorage.setItem("token", (0, _stringify2.default)(user.token));
                            _this2.$router.push({ path: "/monitor/map" });
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        setCookie: function setCookie(c_name, c_pwd, exdays) {
            var exdate = new Date();
            exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays);
            window.document.cookie = "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
            window.document.cookie = "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
        },
        getCookie: function getCookie() {
            this.ruleForm.account = '';
            this.ruleForm.password = '';
            if (document.cookie.length > 0) {
                var arr = document.cookie.split('; ');
                for (var i = 0; i < arr.length; i++) {
                    var arr2 = arr[i].split('=');
                    if (arr2[0] == 'userName') {
                        this.ruleForm.account = arr2[1];
                    } else if (arr2[0] == 'userPwd') {
                        this.spypassword = 'password';
                        this.ruleForm.password = arr2[1];
                    }
                }
            }
        },
        clearCookie: function clearCookie() {
            this.setCookie("", "", -1);
        },
        toForgotPwd: function toForgotPwd() {
            if (!this.ruleForm.account) {
                this.$message({
                    type: 'warning',
                    message: '请先填写账号'
                });
            } else {
                if (this.ruleForm.account === this.usrCloudUser) {
                    this.$router.push({
                        path: '/forgotPwd',
                        query: { name: this.ruleForm.account }
                    });
                } else {
                    this.$router.push({
                        path: '/forgotPwdL2',
                        query: { name: this.ruleForm.account }
                    });
                }
            }
        }
    }
};

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {};

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(174);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(69);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(82);

var _assign2 = _interopRequireDefault(_assign);

exports.showFullScreenLoading = showFullScreenLoading;
exports.tryHideFullScreenLoading = tryHideFullScreenLoading;

var _babelPolyfill = __webpack_require__(366);

var _babelPolyfill2 = _interopRequireDefault(_babelPolyfill);

var _vue = __webpack_require__(12);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(369);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(161);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(368);

__webpack_require__(367);

var _vueRouter = __webpack_require__(162);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(81);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(109);

var _vuex2 = _interopRequireDefault(_vuex);

var _axios = __webpack_require__(160);

var _axios2 = _interopRequireDefault(_axios);

var _filter = __webpack_require__(364);

var _filter2 = _interopRequireDefault(_filter);

var _router = __webpack_require__(80);

var _router2 = _interopRequireDefault(_router);

__webpack_require__(365);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);


_vue2.default.prototype.usrCloudUser = 'hlfchina';

_vue2.default.prototype.$axios = _axios2.default;

_axios2.default.defaults.withCredentials = true;

var loading = void 0;

function startLoading() {
    loading = _elementUi.Loading.service({
        lock: true,
        text: '加载中……',
        background: 'rgba(0, 0, 0, 0)'
    });
}
function endLoading() {
    loading.close();
}
var needLoadingRequestCount = 0;
function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading();
    }
    needLoadingRequestCount++;
}

function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return;
    needLoadingRequestCount--;
    if (needLoadingRequestCount === 0) {
        endLoading();
    }
}

_axios2.default.interceptors.request.use(function (config) {
    var user = JSON.parse(sessionStorage.getItem('user') || '{}');
    if (user.token) {
        if (config.url.indexOf('/service') == 0) {
            config.headers['token'] = user.token;
            config.headers['loginuser'] = user.account;
        }
        if (typeof config.data === 'string') {
            config.data = config.data + "&token=" + user.token;
        } else {
            config.data = config.data || {};
            config.data = (0, _assign2.default)(config.data, { token: user.token });
        }
    }
    showFullScreenLoading();
    return config;
}, function (error) {
    console.log(error);
});
_axios2.default.interceptors.response.use(function (res) {
    console.log('res=====', res);
    if (res.status === 200 && res.data.status != 0) {
        if (res.data.status === 4010) {
            _vue2.default.prototype.$message({
                message: '会话失效，请重新登录',
                type: 'warning'
            });
            _router2.default.replace('/login');
        } else if (res.data.status === 5126) {} else {
            res.config.responseType !== 'blob' && res.data.info && _vue2.default.prototype.$message({
                message: res.data.info,
                type: 'warning'
            });
        }
    }
    tryHideFullScreenLoading();
    return res;
}, function (error) {
    tryHideFullScreenLoading();
    _vue2.default.prototype.$message({
        type: 'error',
        message: '系统异常，请稍后再试'
    });
    return _promise2.default.reject(error);
});

(0, _keys2.default)(_filter2.default).forEach(function (k) {
    return _vue2.default.filter(k, _filter2.default[k]);
});

_vue2.default.filter('DateFormat', function (dataStr, pattern) {
    return (0, _moment2.default)(dataStr).format('YYYY-MM-DD HH:mm:ss');
});
_vue2.default.filter('DateFormatLong', function (dataStr, pattern) {
    if (dataStr === 0) {
        return '--';
    }
    return _moment2.default.unix(dataStr).format(pattern);
});

new _vue2.default({
    router: _router2.default,
    store: _store2.default,

    render: function render(h) {
        return h(_App2.default);
    }
}).$mount('#app');

/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getters = {
  account: function account(state) {
    return state.user.account;
  },
  name: function name(state) {
    return state.user.name;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  addRoutes: function addRoutes(state) {
    return state.permission.addRoutes;
  }
};
exports.default = getters;

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = __webpack_require__(69);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(70);

var _extends3 = _interopRequireDefault(_extends2);

exports.filterAsyncRoutes = filterAsyncRoutes;

var _router = __webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasPermission(roles, route) {
	if (route.meta && route.meta.roles) {
		return roles.some(function (role) {
			return route.meta.roles.includes(role);
		});
	} else {
		return true;
	}
}

function filterAsyncRoutes(routes, roles) {
	var res = [];

	routes.forEach(function (route) {
		var tmp = (0, _extends3.default)({}, route);
		if (hasPermission(roles, tmp)) {
			if (tmp.children) {
				tmp.children = filterAsyncRoutes(tmp.children, roles);
			}
			res.push(tmp);
		}
	});

	return res;
}

var state = {
	routes: [],
	addRoutes: []
};

var mutations = {
	SET_ROUTES: function SET_ROUTES(state, routes) {
		state.addRoutes = routes;
		state.routes = _router.constantRoutes.concat(routes);
	}
};

var actions = {
	generateRoutes: function generateRoutes(_ref, roles) {
		var commit = _ref.commit;

		return new _promise2.default(function (resolve) {
			var accessedRoutes = void 0;

			accessedRoutes = filterAsyncRoutes(_router.asyncRoutes, roles);
			commit('SET_ROUTES', accessedRoutes);
			resolve(accessedRoutes);
		});
	}
};

exports.default = {
	namespaced: true,
	state: state,
	mutations: mutations,
	actions: actions
};

/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(176);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(175);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(69);

var _promise2 = _interopRequireDefault(_promise);

var _api = __webpack_require__(163);

var _auth = __webpack_require__(173);

var _router = __webpack_require__(80);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  account: (0, _auth.getAccount)(),
  name: '',
  avatar: '',
  introduction: '',
  roles: []
};

var mutations = {
  SET_ACCOUNT: function SET_ACCOUNT(state, account) {
    state.account = account;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  }
};

var actions = {
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var username = userInfo.username,
        password = userInfo.password;

    return new _promise2.default(function (resolve, reject) {
      (0, _api.login)({ username: username.trim(), password: password }).then(function (response) {
        var data = response.data;

        commit('SET_ACCOUNT', data.account);
        (0, _auth.setAccount)(data.account);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getInfo: function getInfo(_ref2) {
    var commit = _ref2.commit,
        state = _ref2.state;

    return new _promise2.default(function (resolve, reject) {
      console.log('here--------------');

      var params = {
        account: JSON.parse(sessionStorage.getItem('account'))
      };

      (0, _api.getRoleMenus)({ params: params }).then(function (response) {

        var data = response.data[0].roleType;


        if (!data) {
          reject('Verification failed, please Login again.');
        }

        var roles = [data];

        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }

        commit('SET_ROLES', roles);

        resolve(roles);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  logout: function logout(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit('SET_ACCOUNT', '');
    commit('SET_ROLES', []);
    (0, _auth.removeAccount)();
    (0, _router.resetRouter)();
    console.log("--------------logout");
  },
  resetAccount: function resetAccount(_ref4) {
    var commit = _ref4.commit;

    return new _promise2.default(function (resolve) {
      commit('SET_ACCOUNT', '');
      commit('SET_ROLES', []);
      (0, _auth.removeAccount)();
      resolve();
    });
  },
  changeRoles: function changeRoles(_ref5, role) {
    var _this = this;

    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    return new _promise2.default(function () {
      var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(resolve) {
        var account, _ref7, roles, accessRoutes;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                account = role + '-account';


                commit('SET_ACCOUNT', account);
                (0, _auth.setAccount)(account);

                _context.next = 5;
                return dispatch('getInfo');

              case 5:
                _ref7 = _context.sent;
                roles = _ref7.roles;


                (0, _router.resetRouter)();

                _context.next = 10;
                return dispatch('permission/generateRoutes', roles, { root: true });

              case 10:
                accessRoutes = _context.sent;

                _router2.default.addRoutes(accessRoutes);

                resolve();

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }());
  }
};

exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 688:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 689:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 690:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 236,
	"./af.js": 236,
	"./ar": 243,
	"./ar-dz": 237,
	"./ar-dz.js": 237,
	"./ar-kw": 238,
	"./ar-kw.js": 238,
	"./ar-ly": 239,
	"./ar-ly.js": 239,
	"./ar-ma": 240,
	"./ar-ma.js": 240,
	"./ar-sa": 241,
	"./ar-sa.js": 241,
	"./ar-tn": 242,
	"./ar-tn.js": 242,
	"./ar.js": 243,
	"./az": 244,
	"./az.js": 244,
	"./be": 245,
	"./be.js": 245,
	"./bg": 246,
	"./bg.js": 246,
	"./bm": 247,
	"./bm.js": 247,
	"./bn": 248,
	"./bn.js": 248,
	"./bo": 249,
	"./bo.js": 249,
	"./br": 250,
	"./br.js": 250,
	"./bs": 251,
	"./bs.js": 251,
	"./ca": 252,
	"./ca.js": 252,
	"./cs": 253,
	"./cs.js": 253,
	"./cv": 254,
	"./cv.js": 254,
	"./cy": 255,
	"./cy.js": 255,
	"./da": 256,
	"./da.js": 256,
	"./de": 259,
	"./de-at": 257,
	"./de-at.js": 257,
	"./de-ch": 258,
	"./de-ch.js": 258,
	"./de.js": 259,
	"./dv": 260,
	"./dv.js": 260,
	"./el": 261,
	"./el.js": 261,
	"./en-SG": 262,
	"./en-SG.js": 262,
	"./en-au": 263,
	"./en-au.js": 263,
	"./en-ca": 264,
	"./en-ca.js": 264,
	"./en-gb": 265,
	"./en-gb.js": 265,
	"./en-ie": 266,
	"./en-ie.js": 266,
	"./en-il": 267,
	"./en-il.js": 267,
	"./en-nz": 268,
	"./en-nz.js": 268,
	"./eo": 269,
	"./eo.js": 269,
	"./es": 272,
	"./es-do": 270,
	"./es-do.js": 270,
	"./es-us": 271,
	"./es-us.js": 271,
	"./es.js": 272,
	"./et": 273,
	"./et.js": 273,
	"./eu": 274,
	"./eu.js": 274,
	"./fa": 275,
	"./fa.js": 275,
	"./fi": 276,
	"./fi.js": 276,
	"./fo": 277,
	"./fo.js": 277,
	"./fr": 280,
	"./fr-ca": 278,
	"./fr-ca.js": 278,
	"./fr-ch": 279,
	"./fr-ch.js": 279,
	"./fr.js": 280,
	"./fy": 281,
	"./fy.js": 281,
	"./ga": 282,
	"./ga.js": 282,
	"./gd": 283,
	"./gd.js": 283,
	"./gl": 284,
	"./gl.js": 284,
	"./gom-latn": 285,
	"./gom-latn.js": 285,
	"./gu": 286,
	"./gu.js": 286,
	"./he": 287,
	"./he.js": 287,
	"./hi": 288,
	"./hi.js": 288,
	"./hr": 289,
	"./hr.js": 289,
	"./hu": 290,
	"./hu.js": 290,
	"./hy-am": 291,
	"./hy-am.js": 291,
	"./id": 292,
	"./id.js": 292,
	"./is": 293,
	"./is.js": 293,
	"./it": 295,
	"./it-ch": 294,
	"./it-ch.js": 294,
	"./it.js": 295,
	"./ja": 296,
	"./ja.js": 296,
	"./jv": 297,
	"./jv.js": 297,
	"./ka": 298,
	"./ka.js": 298,
	"./kk": 299,
	"./kk.js": 299,
	"./km": 300,
	"./km.js": 300,
	"./kn": 301,
	"./kn.js": 301,
	"./ko": 302,
	"./ko.js": 302,
	"./ku": 303,
	"./ku.js": 303,
	"./ky": 304,
	"./ky.js": 304,
	"./lb": 305,
	"./lb.js": 305,
	"./lo": 306,
	"./lo.js": 306,
	"./lt": 307,
	"./lt.js": 307,
	"./lv": 308,
	"./lv.js": 308,
	"./me": 309,
	"./me.js": 309,
	"./mi": 310,
	"./mi.js": 310,
	"./mk": 311,
	"./mk.js": 311,
	"./ml": 312,
	"./ml.js": 312,
	"./mn": 313,
	"./mn.js": 313,
	"./mr": 314,
	"./mr.js": 314,
	"./ms": 316,
	"./ms-my": 315,
	"./ms-my.js": 315,
	"./ms.js": 316,
	"./mt": 317,
	"./mt.js": 317,
	"./my": 318,
	"./my.js": 318,
	"./nb": 319,
	"./nb.js": 319,
	"./ne": 320,
	"./ne.js": 320,
	"./nl": 322,
	"./nl-be": 321,
	"./nl-be.js": 321,
	"./nl.js": 322,
	"./nn": 323,
	"./nn.js": 323,
	"./pa-in": 324,
	"./pa-in.js": 324,
	"./pl": 325,
	"./pl.js": 325,
	"./pt": 327,
	"./pt-br": 326,
	"./pt-br.js": 326,
	"./pt.js": 327,
	"./ro": 328,
	"./ro.js": 328,
	"./ru": 329,
	"./ru.js": 329,
	"./sd": 330,
	"./sd.js": 330,
	"./se": 331,
	"./se.js": 331,
	"./si": 332,
	"./si.js": 332,
	"./sk": 333,
	"./sk.js": 333,
	"./sl": 334,
	"./sl.js": 334,
	"./sq": 335,
	"./sq.js": 335,
	"./sr": 337,
	"./sr-cyrl": 336,
	"./sr-cyrl.js": 336,
	"./sr.js": 337,
	"./ss": 338,
	"./ss.js": 338,
	"./sv": 339,
	"./sv.js": 339,
	"./sw": 340,
	"./sw.js": 340,
	"./ta": 341,
	"./ta.js": 341,
	"./te": 342,
	"./te.js": 342,
	"./tet": 343,
	"./tet.js": 343,
	"./tg": 344,
	"./tg.js": 344,
	"./th": 345,
	"./th.js": 345,
	"./tl-ph": 346,
	"./tl-ph.js": 346,
	"./tlh": 347,
	"./tlh.js": 347,
	"./tr": 348,
	"./tr.js": 348,
	"./tzl": 349,
	"./tzl.js": 349,
	"./tzm": 351,
	"./tzm-latn": 350,
	"./tzm-latn.js": 350,
	"./tzm.js": 351,
	"./ug-cn": 352,
	"./ug-cn.js": 352,
	"./uk": 353,
	"./uk.js": 353,
	"./ur": 354,
	"./ur.js": 354,
	"./uz": 356,
	"./uz-latn": 355,
	"./uz-latn.js": 355,
	"./uz.js": 356,
	"./vi": 357,
	"./vi.js": 357,
	"./x-pseudo": 358,
	"./x-pseudo.js": 358,
	"./yo": 359,
	"./yo.js": 359,
	"./zh-cn": 360,
	"./zh-cn.js": 360,
	"./zh-hk": 361,
	"./zh-hk.js": 361,
	"./zh-tw": 362,
	"./zh-tw.js": 362
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 691;

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(689)

var Component = __webpack_require__(68)(
  /* script */
  null,
  /* template */
  __webpack_require__(710),
  /* scopeId */
  "data-v-6d70149a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(690)

var Component = __webpack_require__(68)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(711),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(686)
__webpack_require__(685)

var Component = __webpack_require__(68)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(707),
  /* scopeId */
  "data-v-368ccfab",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(688)

var Component = __webpack_require__(68)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(709),
  /* scopeId */
  "data-v-39118732",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "password"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "login-logo",
    attrs: {
      "src": __webpack_require__(363)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("节能增效智联平台")]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.ruleForm.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "account", $$v)
      },
      expression: "ruleForm.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.spypassword,
      "auto-complete": "off",
      "placeholder": "密码"
    },
    on: {
      "focus": function($event) {
        _vm.spypassword = 'password'
      }
    },
    model: {
      value: (_vm.ruleForm.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "password", $$v)
      },
      expression: "ruleForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticClass: "login-button",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2($event)
      }
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-checkbox', {
    staticClass: "remember",
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住密码")])], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 12
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#fff"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toForgotPwd
    }
  }, [_vm._v("忘记密码")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("版权所有：江苏汇励丰节能环保科技有限公司")])])
},staticRenderFns: []}

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 709:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n\tmain\n")])
},staticRenderFns: []}

/***/ }),

/***/ 710:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(363)
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_vm._v(_vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "tag": "div",
      "to": "/analysis/mainAnalyze"
    }
  }, [_vm._v("分析报表")])], 1), _vm._v(" "), _c('el-dropdown-item', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "tag": "div",
      "to": "/trigger/alarmHistory"
    }
  }, [_vm._v("告警历史")])], 1), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-scrollbar', {
    staticClass: "el-scrollbar-self"
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.permission_routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      key: item.id,
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls,
      staticStyle: {
        "height": "15px",
        "width": "15px"
      }
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      key: item.id,
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls,
      staticStyle: {
        "height": "15px",
        "width": "15px"
      }
    }), _vm._v(_vm._s(item.children[0].name))]) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.permission_routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      key: item.id,
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          return _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          return _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path == child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            return _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    }), 0)] : [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path == item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "padding-left": "20px",
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          return _vm.$router.push(item.children[0].path)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })])])]], 2) : _vm._e()
  }), 0)], 1)], 1)]), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./permission.js": 419,
	"./user.js": 420
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;

/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/loginbg.f1b1a6d.png";

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.asyncRoutes = exports.constantRoutes = undefined;
exports.resetRouter = resetRouter;

var _vue = __webpack_require__(12);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(162);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Login = __webpack_require__(705);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(703);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(704);

var _Home2 = _interopRequireDefault(_Home);

var _Main = __webpack_require__(706);

var _Main2 = _interopRequireDefault(_Main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var constantRoutes = exports.constantRoutes = [{
    path: '/login',
    component: _Login2.default,
    name: '',
    hidden: true
}, {
    path: '/forgotPwd',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(719)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    name: '',
    hidden: true
}, {
    path: '/forgotPwdL2',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(720)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    name: '',
    hidden: true
}, {
    path: '/404',
    component: _2.default,
    name: '',
    hidden: true
}];

var asyncRoutes = exports.asyncRoutes = [{
    path: '/device/detail',
    component: function component(resolve) {
        return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(723)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    name: '',
    hidden: true
}, {
    path: '/',
    component: _Home2.default,
    name: '监控中心',
    iconCls: 'fa fa-tv',
    children: [{ path: '/monitor/map', component: function component(resolve) {
            return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(727)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '地图展示' }, { path: '/device/list', component: function component(resolve) {
            return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(725)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '设备列表', meta: { roles: ['admin'] } }, { path: '/device/listL2', component: function component(resolve) {
            return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(726)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '设备列表', meta: { roles: ['region_1', 'third_role_1'] } }]
}, {
    path: '/',
    component: _Home2.default,
    name: '设备管理',
    iconCls: 'fa fa-laptop',
    children: [{ path: '/device/extinfo', component: function component(resolve) {
            return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(724)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '设备拓展信息', meta: { roles: ['admin'] } }],
    meta: { roles: ['admin', 'region_1', 'third_role_1'] }
}, {
    path: '/',
    component: _Home2.default,
    name: '数据管理',
    iconCls: 'fa fa-database',
    children: [{ path: '/history', component: function component(resolve) {
            return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(722)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '历史数据' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '能耗管理',
    leaf: true,
    iconCls: 'fa fa-line-chart',
    children: [{ path: '/analysis/energy', component: function component(resolve) {
            return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(721)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '能耗分析' }]
}, {
    path: '/',
    component: _Home2.default,
    name: '预警管理',
    iconCls: 'fa fa-bell',
    children: [{ path: '/trigger/list', component: function component(resolve) {
            return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(731)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '预警项列表', meta: { roles: ['admin'] } }, { path: '/trigger/listL2', component: function component(resolve) {
            return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(732)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '预警项列表', meta: { roles: ['region_1', 'third_role_1'] } }, { path: '/trigger/add', component: function component(resolve) {
            return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(372)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '添加预警设置', meta: { roles: ['admin'] } }, { path: '/trigger/addL2', component: function component(resolve) {
            return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(373)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '添加预警设置', meta: { roles: ['region_1', 'third_role_1'] } }, { path: '/trigger/edit', component: function component(resolve) {
            return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(372)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '编辑预警设置', hidden: true, meta: { roles: ['admin'] } }, { path: '/trigger/editL2', component: function component(resolve) {
            return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(373)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '编辑预警设置', hidden: true, meta: { roles: ['region_1', 'third_role_1'] } }, { path: '/trigger/contact', component: function component(resolve) {
            return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(729)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '报警联系人/组', meta: { roles: ['admin'] } }, { path: '/trigger/contactL2', component: function component(resolve) {
            return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(730)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '报警联系人', meta: { roles: ['region_1', 'third_role_1'] } }, { path: '/trigger/alarmHistory', component: function component(resolve) {
            return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(728)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '报警记录', meta: { roles: ['admin', "region_1", 'third_role_1'] } }],
    meta: { roles: ['admin', 'region_1', 'third_role_1'] }
}, {
    path: '/',
    component: _Home2.default,
    name: '用户中心',
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/user/role', component: function component(resolve) {
            return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(735)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '角色管理', meta: { roles: ['admin'] } }, { path: '/user/user', component: function component(resolve) {
            return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(736)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '子用户管理', meta: { roles: ['admin', 'region_1'] } }, { path: '/user/info', component: function component(resolve) {
            return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(737)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '用户信息', meta: { roles: ['admin'] } }, { path: '/user/password', component: function component(resolve) {
            return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(733)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '用户密码', meta: { roles: ['admin'] } }, { path: '/user/wxbind', component: function component(resolve) {
            return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(739)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '微信绑定管理', meta: { roles: ['admin'] } }, { path: '/user/wxbindL2', component: function component(resolve) {
            return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(740)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '微信绑定管理', meta: { roles: ['region_1', 'third_role_1'] } }, { path: '/user/infoL2', component: function component(resolve) {
            return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(738)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '用户信息', meta: { roles: ['region_1', 'third_role_1'] } }, { path: '/user/passwordL2', component: function component(resolve) {
            return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(734)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }, name: '用户密码', meta: { roles: ['region_1', 'third_role_1'] } }],
    meta: { roles: ['admin', 'region_1', 'third_role_1'] }
}, { path: '*', redirect: '/404', hidden: true }];

var createRouter = function createRouter() {
    return new _vueRouter2.default({
        routes: constantRoutes
    });
};

var router = createRouter();

function resetRouter() {
    var newRouter = createRouter();
    router.matcher = newRouter.matcher;
}

exports.default = router;

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(12);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(109);

var _vuex2 = _interopRequireDefault(_vuex);

var _getters = __webpack_require__(418);

var _getters2 = _interopRequireDefault(_getters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var modulesFiles = __webpack_require__(715);

var modules = modulesFiles.keys().reduce(function (modules, modulePath) {
  var moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  var value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

var store = new _vuex2.default.Store({
  modules: modules,
  getters: _getters2.default
});

exports.default = store;

/***/ })

},[417]);


// WEBPACK FOOTER //
// static/js/app.a4342d87abbc533dc3e2.js